import { Link } from "react-router-dom";
import Seo, { breadcrumbs } from "../components/Seo";
import { SectionHeader, Hero } from "../components/UI";
import { siteConfig } from "../config";

const HUB_LINK = (txt, href, ext) => ext ? (
  <a href={href} target="_blank" rel="noopener noreferrer" className="ssc-card block">
    <div className="font-extrabold text-[var(--ssc-navy)]">{txt} ↗</div>
  </a>
) : (
  <Link to={href} className="ssc-card block">
    <div className="font-extrabold text-[var(--ssc-navy)]">{txt}</div>
  </Link>
);

export function FinanceTradeHub() {
  return (
    <main id="main-content">
      <Seo
        title="Finance & Trade | Scott Sells Chevys"
        description="Payment help, trade-in guidance, lease and finance answers, and the Build My Own Deal experience."
        canonicalPath="/finance-trade"
        jsonLd={[breadcrumbs([{ name: "Home", path: "/" }, { name: "Finance & Trade", path: "/finance-trade" }])]}
      />
      <Hero title="Finance & Trade" subtitle="Trade in, finance, lease, or plan around a payment — Scott helps you find a direction." />
      <section className="ssc-section">
        <div className="ssc-container grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {HUB_LINK("Payment Help", "/payment-help")}
          {HUB_LINK("Value My Trade", "/value-my-trade")}
          {HUB_LINK("Build My Own Deal", "/scotts-deal-desk")}
          {HUB_LINK("Lease Help", "/lease-help")}
          {HUB_LINK("Finance Help", "/finance-help")}
          {HUB_LINK("Get Pre-Qualified", siteConfig.links.financeApply, true)}
          {HUB_LINK("Apply for Financing", siteConfig.links.financeApply, true)}
          {HUB_LINK("Trade-In Checklist", "/trade-in-checklist")}
          {HUB_LINK("Payment Calculator", "/payment-calculator")}
          {HUB_LINK("Shop Chevrolet Accessories", siteConfig.links.accessories, true)}
        </div>
      </section>
    </main>
  );
}

export function ResourcesHub() {
  return (
    <main id="main-content">
      <Seo
        title="Resources | Scott Sells Chevys"
        description="EV help, vehicle alerts, reviews, FAQs, service areas, car buying tips, and the new vs used guide."
        canonicalPath="/resources"
        jsonLd={[breadcrumbs([{ name: "Home", path: "/" }, { name: "Resources", path: "/resources" }])]}
      />
      <Hero title="Resources" subtitle="Helpful guides, FAQs, and tools for shopping smarter." />
      <section className="ssc-section">
        <div className="ssc-container grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {HUB_LINK("EV Help", "/ev-help")}
          {HUB_LINK("Vehicle Alerts", "/vehicle-alerts")}
          {HUB_LINK("Reviews", "/reviews")}
          {HUB_LINK("FAQ", "/faq")}
          {HUB_LINK("Service Areas", "/service-areas")}
          {HUB_LINK("Car Buying Tips", "/car-buying-tips")}
          {HUB_LINK("New vs Used Guide", "/new-vs-used")}
          {HUB_LINK("Contact Scott", "/contact")}
        </div>
      </section>
    </main>
  );
}
